/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unlock': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M785.2 452.5v469.9c0 8.6-6.9 15.1-15.1 15.1H230.3c-8.6 0-15.5-6.6-15.5-15.1V452.5c0-8.1 6.9-15.1 15.5-15.1h42.4c5.6 0 10.5-1.4 13.2-3.9 0 0 .9-2 .9-3.2v-6.9c0-35.9 0-71.7.3-108 .3-21.8 0-43.8 3.3-65.2C309.2 120.7 438 36.4 564.4 69.9 654.2 94.1 721.8 173 726.6 265.2c2.1 38.3 1.7 77 1.6 115.6h-81.9c.1-29.8.3-59.8 0-89.9-.3-11.5-1-23.7-3.2-35.3-13.6-66.4-74.5-113.9-143.9-110.2-65.5 3-126.4 60.5-128.4 126.1-1.6 50-1 100.1-1.4 150v7.9c0 1.6 1 3 2.7 3.9 0 0 8.1 3.6 13.7 3.6H770c8.3.1 15.2 7 15.2 15.6z"/>'
  }
})
